import request from "@/CommonDP/utils/request";

export function saveGroup(params) {
  return request.post("/dyn-list/save", params);
}

export function saveListConfigJSON(params, listPageId) {
  return request.post(`/dyn-list/save-json/${listPageId}`, params);
}

export function querySqlByTableName(tableName) {
  return request.get(`/dyn-list/makeQuerySqlByTableName/${tableName}`);
}

// 新增
export function generateQuerySql(params) {
  return request.post(`/dyn-list/generateQuerySql`, params).then((res) => res);
}

// 多字段模糊搜索生成sql片段
export function generateQueryMultiFieldSql(params) {
  return request.post(`/dyn-list/generate/multiFieldSearchQuerySql`, params).then((res) => res);
}
// TODO
export function saveSql(metaId, param) {
  return request.post(`dyn-list/updateQuerySql/${metaId}`, param).then((res) => res);
}
export function getListConfigJSON(listPageId) {
  return request.get(`/dyn-list/queryJsonByListPageId?listPageId=${listPageId}`);
}

export function requestBatchDel(params, id) {
  return request.post(`/dyn-common/batchDelete/${id}`, params);
}

export function requestBatchDelByVformWidget(id, primaryKeyValueList) {
  return request.post(`/dyn-common/delete-slave/${id}?id=${primaryKeyValueList}`);
}

export function getListConfigJSONByFormCode(formCode) {
  return request.get(`/dyn-list/queryJsonByFormCode?formCode=${formCode}`);
}

export function queryMajorList(groupID) {
  return request.get(`/dynMeta-group/queryDynMetaListByGroupID?groupId=${groupID}`);
}

export function queryDynMetaPrimaryKeyList(arr) {
  return request.post(`/dynMeta-column/queryDynMetaPrimaryKeyList`, arr);
}

export function requestFieldList(listPageId) {
  return request.get(`/dyn-list/queryColumns?listPageId=${listPageId}`);
}

export function requestFormList(listPageId) {
  return request.get(`/dyn-list/queryDynFormListByListPageId?listPageId=${listPageId}`);
}

export function requestTableList() {
  return request.get(`/dynMeta-group/list-page/tree`);
}

export function requestMetaList(listPageId) {
  return request.get(`/dyn-list/queryMetaListByListPageId?listPageId=${listPageId}`);
}

export function requestTableListAndFromList(listPageId) {
  return request.get(`/dyn-custom-page/listByPageId/${listPageId}`);
}

export function requestAuthorizeList(listPageId) {
  return request.get(`/sys-resource-action/list?resourceId=system&isQueryDefault=false`);
}

export function requestFormJson(formId) {
  return request.get(`/dyn-form-design/queryJsonByFormID?formId=${formId}`);
}

export function dynTableList(groupID) {
  return request.get(`/dynTable/list?groupID=${groupID}`).then((res) => res);
}

export function getDdynTableList(groupID) {
  return request.get(`/dyn-list/queryListByGroupID?groupId=${groupID}`).then((res) => res);
}
export function getDdynTableListDetail(listPageId) {
  return request.get(`/dyn-list/detail?listPageId=${listPageId}`).then((res) => res);
}
export function updateDynTableList(params) {
  return request.post(`/dyn-list/update`, params).then((res) => res);
}

export function delDynTableList(params) {
  return request.post(`/dyn-list/batchDelete`, params).then((res) => res);
}

export function cloneDynTableList(params) {
  return request.post(`/dyn-list/clone`, params);
}

export function dynFormGroupList(params) {
  return request.post(`/dynMeta-group/form-tree`, params).then((res) => res);
}

export function exportExcel(params, listPageId) {
  return request({
    responseType: "blob",
    url: `/dyn-common/exportExcel/${listPageId}`,
    method: "post",
    data: params
  });
}

export function getPrimekey(listPageId) {
  return request.get(`/dyn-list/queryPrimaryKeyFieldByListPageId?listPageId=${listPageId}`).then((res) => res);
}

// 动态标准通用得增删改查接口
export function dynamicPageList(params, { pageNo, pageSize, tabId = "" }, listPageId) {
  return request.post(`/dyn-common/page-list/${listPageId}?pageNo=${pageNo}&pageSize=${pageSize}&tabId=${tabId}`, JSON.stringify(params)).then((res) => res);
}

export function getDownloadDesignTemplateInfo(flowInstanceId, businessId) {
  // 下载
  return request({
    url: `/flowNew/archive/download?flowInstanceId=${flowInstanceId || ""}&businessId=${businessId || ""}`,
    method: "get",
    responseType: "blob"
  });
}
